import { ReservationOccasion } from '../../../../../services/exports/Constants';

export default {
  updated_details: 'Päivitetyt tiedot',
  previous_details: 'Aiemmat tiedot',
  fields: {
    datetime: 'Päivämäärä:',
    email: 'Sähköposti:',
    phone_number: 'Puhelinnumero:',
    customer: 'Asiakas:',
    source: 'Lähde:',
    guests: 'Vieraat:',
    comment: 'Kommentti:',
    confirmed_at: 'Vahvistettu:',
    status: 'Tila:',
    occasion: 'Tilaisuus:',
    created_at: 'Luotu:',
  },
  status: {
    confirmed: 'Vahvistettu',
    pending: 'Odottaa hyväksyntää',
    canceled: 'Peruttu',
    canceled_by_customer: 'Asiakas peruutti',
    rejected: 'Hylätty',
    removed: 'Poistettu',
  },
  buttons: {
    confirm: 'Vahvista',
    reject: 'Hylkää',
    cancel: 'Peruuta',
    edit: 'Muokkaa',
    remove: 'Poista',
  },
  occasion: {
    [ReservationOccasion.Birthday]: 'Syntymäpäivä',
    [ReservationOccasion.Anniversary]: 'Vuosipäivä',
    [ReservationOccasion.Date]: 'Päivämäärä',
    [ReservationOccasion.SpecialOccasion]: 'Erityistilaisuus',
    [ReservationOccasion.BusinessMeal]: 'Liikelounas',
  },
  remove_reservation_modal: {
    title: 'Haluatko varmasti poistaa varauksen?',
    buttons: {
      remove: 'Poista',
      cancel: 'Peruuta',
    },
  },
  response_messages: {
    success: 'Varauksen tila päivitetty onnistuneesti. Asiakkaalle on ilmoitettu.',
    error: 'Varauksen tilan päivitys epäonnistui. Yritä uudelleen.',
  },
};
